import { ExternalWarehouseDto } from './external-warehouse.dto';

export class ExternalWarehouse {
    readonly id: string;
    readonly name: string;

    constructor(dto: ExternalWarehouseDto) {
        this.id = dto.id;
        this.name = dto.name;
    }
}
